import { createRouter, createWebHistory } from "vue-router";
import Login from "@/views/Login.vue"; // ログインページのビューをインポートします
import TopPage from "@/views/TopPage.vue"; // トップページのビューをインポートします
import ArticleInput from "@/views/articleInput.vue";
import PredictiveInput from "@/views/predictiveInput.vue";
import SearchArticle from "@/views/searchArticle.vue";
import SearchYoutube from "@/views/searchYoutube.vue";
import YoutubeInput from "@/views/youtubeInput.vue";
import MaintenanceDisplay from "@/views/MaintenanceDisplay.vue";
import specialSite from "@/views/specialSite.vue";
import ranking from "@/views/ranking.vue";
import CSVupload from "@/views/CSVupload.vue";
import XMLManualUpdate from "@/views/XMLManualUpdate.vue";
import userManagement from "@/views/userManagement.vue";
import { useRoleStore } from "@/store/roleStore";
import { useStore } from "@/store/authStore";

import useRole from "@/components/role.js";
const routerHistory = createWebHistory(process.env.BASE_URL);

const defineRoutes = (PERMISSIONS) => {
  return [
    {
      path: "/",
      name: "home",
      component: TopPage, // ホームルートをトップページに変更します
      meta: { requiresAuth: true },
      children: [
        {
          path: "/articleInput",
          component: ArticleInput,
          meta: { requiresAuth: true, title: "記事編集 | " },
        },
        {
          path: "/articleInput/:id",
          name: "ArticleInput",
          component: ArticleInput,
          props: true,
          meta: { requiresAuth: true, title: "記事編集 | " },
        },
        {
          path: "/predictiveInput",
          component: PredictiveInput,
          meta: { requiresAuth: true, title: "予想入力 | " },
        },
        {
          path: "/predictiveInput/date=:date/place=:place/race=:race",
          name: "Search",
          component: PredictiveInput,
          props: true,
          meta: { requiresAuth: true, title: "予想入力 | " },
        },
        {
          path: "/searchArticle",
          name: "searchArticle",
          component: SearchArticle,
          meta: { requiresAuth: true, title: "記事検索 | " },
          props: (route) => ({ query: route.query }),
        },
        {
          path: "/searchYoutube",
          name: "searchYoutube",
          component: SearchYoutube,
          meta: { requiresAuth: true, title: "YouTube検索 | " },
          props: (route) => ({ query: route.query }),
        },
        {
          path: "/youtubeInput",
          component: YoutubeInput,
          meta: { requiresAuth: true, title: "YouTube編集 | " },
        },
        {
          path: "/youtubeInput/:id",
          name: "YoutubeInput",
          component: YoutubeInput,
          props: true,
          meta: { requiresAuth: true, title: "YouTube編集 | " },
        },
        {
          path: "/MaintenanceDisplay",
          component: MaintenanceDisplay,
          meta: { requiresAuth: true, title: "メンテナンス中設定 | " },
        },
        {
          path: "/specialSite",
          component: specialSite,
          meta: { requiresAuth: true, title: "ピックアップ | " },
        },
        {
          path: "/ranking",
          component: ranking,
          meta: { requiresAuth: true, title: "アクセスランキング | " },
        },
        {
          path: "/CSVupload",
          component: CSVupload,
          meta: { requiresAuth: true, title: "CSVアップロード | " },
        },
        {
          path: "/XMLManualUpdate",
          component: XMLManualUpdate,
          meta: {
            requiresAuth: true,
            requiredPermissions: [PERMISSIONS.XML_DOWNLOAD.code],
            title: "XML随時取得 | ",
          },
        },
        {
          path: "/users",
          component: userManagement,
          meta: {
            requiresAuth: true,
            requiredPermissions: [PERMISSIONS.ADMIN.code],
            title: "ユーザー管理 | ",
          },
        },
      ],
    },
    {
      path: "/login",
      name: "login",
      component: Login, // ログインページへのルートを追加します
      meta: { title: "ログイン" },
    },
    // 必要に応じて他のルートをここに追加します
  ];
};
const { PERMISSIONS } = useRole();

const router = createRouter({
  history: routerHistory,
  routes: defineRoutes(PERMISSIONS), // ここで関数を呼び出す
});

const DEFAULT_TITLE = "日刊ゲンダイボートレースCMS"; // 元のタイトルをここにセット

router.beforeEach((to, from, next) => {
  const store = useStore();

  const roleStore = useRoleStore();
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);
  const matchedRoute = to.matched.find(
    (record) => record.meta.requiredPermissions
  );

  document.title = `${to.meta.title || ""}${DEFAULT_TITLE}`;

  const requiredPermissions = matchedRoute
    ? matchedRoute.meta.requiredPermissions
    : [];

  if (requiresAuth && !store.getIsLogin) {
    next("/login");
  } else if (
    requiredPermissions.length &&
    (!Array.isArray(roleStore.role) ||
      !requiredPermissions.every((permission) =>
        roleStore.role.includes(permission)
      ))
  ) {
    // 必要な権限がない場合、未認可ページにリダイレクトするか、エラーメッセージを表示します。
    alert("アクセスする権限がありません");
    next("/");
  } else {
    next();
  }
});

export default router;
